import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ContractSignature } from '../../../models/contract/contract-signature';
import { ContractService } from '../../../services/contract/contract.service';

@Component({
    selector: 'app-legal-text-contract-bra-bas1',
    templateUrl: './legal-text-contract-bra-bas1.component.html',
    styleUrls: ['./legal-text-contract-bra-bas1.component.scss'],
    standalone: false
})
export class LegalTextContractBraBas1Component implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  contractSignature: ContractSignature;

  contract: number = 0;
  document: string = '';
  month: string = '';
  city: string = '';
  uuid: string = '';

  constructor(
    private contractService: ContractService,
    private activatedRoute: ActivatedRoute
  ) {

    this.contractSignature = new ContractSignature;
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    this.activatedRoute.queryParams.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {

      this.uuid = params.uuid;
      this.contractSummarySearch(this.uuid);
    });
  }

  contractSummarySearch(uuid: string) {
    this.contractService
      .getContractSignature(uuid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ContractSignature) => {

        this.contractSignature = response;

        if (this.contractSignature.country === 'BRA') {
          this.city = 'São Paulo'
        }

        const salesDate = new Date(this.contractSignature.salesDate);
        const mes = salesDate.getMonth() + 1;

        switch (mes) {

          case 1:
            this.month = 'janeiro';
            break;

          case 2:
            this.month = 'fevereiro';
            break;

          case 3:
            this.month = 'março';
            break;

          case 4:
            this.month = 'abril';
            break;

          case 5:
            this.month = 'maio';
            break;

          case 6:
            this.month = 'junho';
            break;

          case 7:
            this.month = 'julho';
            break;

          case 8:
            this.month = 'agosto';
            break;

          case 9:
            this.month = 'setembro';
            break;

          case 10:
            this.month = 'outubro';
            break;

          case 11:
            this.month = 'novembro';
            break;

          case 12:
            this.month = 'dezembro';
            break;
        }
      });

  }


}
